import { Component, inject } from '@angular/core';
import { LineButton } from '../../../models/generated/ziroModels';
import { ZiroFormConfig, ZiroFormsValidationState } from '../../../../forms/ziro-forms-models';
import { ZiroFormAbstractDirective } from '../../../../forms/ziro-form-abstract.directive';
import { ZiroFormStateService } from '../../../../forms/ziro-form-state.service';
import { PhoneButtonsService } from '../../shared/phone-buttons.service';
import { Observable } from 'rxjs';
import { ZiroFormsModule } from '../../../../forms/ziro-forms.module';

enum LineButtonLabelTitle {
  LABEL_TITLE = 'tkey;pages.details.phoneSettings.button.speedDial.label',
  NUMBER_TITLE = 'tkey;pages.details.phoneSettings.button.speedDial.number',
}

interface SelfServeLineFormData {
  extension: string;
  label: string;
}

@Component({
  selector: 'ziro-phone-buttons-line',
  templateUrl: './phone-buttons-line.component.html',
  imports: [ZiroFormsModule],
})
export class PhoneButtonsLineComponent extends ZiroFormAbstractDirective<LineButton, SelfServeLineFormData> {
  protected _ziroFormStateService: ZiroFormStateService;
  private phoneButtonsService = inject(PhoneButtonsService);

  fieldGroups = {
    textInputs: ['extension', 'label'],
  };

  formConfig = {
    fields: {
      extension: {
        disabled: () => true,
        disabledTooltip: 'tkey;shared.device.phone.phone_buttons.config_pane.disabled_extension',
        label: LineButtonLabelTitle.NUMBER_TITLE,
        dataAutomation: 'phone-button-line-extension',
        required: false,
      },
      label: {
        label: LineButtonLabelTitle.LABEL_TITLE,
        dataAutomation: 'phone-button-line-label',
        required: false,
        validation: [
          {
            validator: (val: string) =>
              this.phoneButtonsService.validLineLabelPattern(val)
                ? ZiroFormsValidationState.VALID
                : ZiroFormsValidationState.INVALID,
            message: 'tkey;validators.global.error.pattern',
          },
          {
            validator: (val: string) =>
              this.phoneButtonsService.validLabelLength(val)
                ? ZiroFormsValidationState.VALID
                : ZiroFormsValidationState.INVALID,
            message: {
              content: 'tkey;validators.global.error.maxlength',
              params: {
                maxlength: 30,
              },
            },
          },
        ],
      },
    },
    options: {
      columnClasses: {
        label: 'col-3 text-lg-end',
        input: 'col-9',
      },
    },
  } as ZiroFormConfig;

  submit(): Observable<any> {
    return this.parentSubmit$();
  }

  toEntity = (formData: SelfServeLineFormData): LineButton => {
    return { ...this.entity, lineFeature: { ...this.entity.lineFeature, label: formData.label } };
  };

  toFormData = (entity: LineButton): SelfServeLineFormData => {
    return {
      extension: entity?.dn?.extension ? entity.dn.extension : '',
      label: entity?.lineFeature?.label ? entity.lineFeature.label : '',
    };
  };
}
